<template>
  <div class="main-container">
    <VacanciesBanner />
    <VacanciesIntro />
    <VacanciesForm />
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import VacanciesBanner from '@/components/vacancies/VacanciesBanner';
import VacanciesIntro from '@/components/vacancies/VacanciesIntro';
import VacanciesForm from '@/components/vacancies/VacanciesForm';

export default {
  name: 'VacanciesView',
  components: {
    VacanciesBanner,
    VacanciesIntro,
    VacanciesForm,
  },
  beforeMount() {
    useMeta({
      title: this.$t('pagenames.vacancies') + ' | AI gym',
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
    });
  },
};
</script>
